import { Severity } from '@rtkwlf/mr-infra-risk';

import { SeverityStatusChip } from '@packages/fenrir/components';
import type { GridSingleSelectColDef } from '@packages/fenrir/components/datagrid';
import {
  getFilteredGridSelectOperators,
  GridSelectOperator,
} from '@packages/fenrir/components/datagrid';

import { translateOptions } from '../translate-options/translate-options';

const riskSeverityOptions = translateOptions(
  Object.values(Severity),
  'riskManagement:risks.riskSeverity',
);

export const riskSeverityColumnType: Omit<GridSingleSelectColDef, 'field'> = {
  display: 'flex',
  flex: 0.2,
  minWidth: 115,
  type: 'singleSelect',
  filterOperators: getFilteredGridSelectOperators([GridSelectOperator.isAnyOf]),
  valueOptions: riskSeverityOptions,
  renderCell: (params) => {
    return <SeverityStatusChip status={params.row.severity} />;
  },
};
